import { makeStyles, Select, MenuItem } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export default function PriceSchemeTable(props) {
    const classes = useStyles();


    return (
        <Table className={classes.table} aria-label="customized table">
        <TableHead>
            <TableRow>
                <TableCell className={classes.headCell}></TableCell>
                {props.headers.map((header) => (
                    <TableCell className={classes.headCell}>{header.ProductFamilyName}</TableCell>
                ))}
            </TableRow>
        </TableHead>
        <TableBody>               
            {props.rows.map((row) => {
                return (
                    <TableRow key={row.periodText + row.cells[0].Price} className={classes.row}>
                        <TableCell className={classes.infoCell} style={{ width: "20%" }}>{row.periodText}</TableCell>
                        {row.cells.map((cell) => (
                            <TableCell style={{ width: "16%", cursor: cell.Price > 0 ? "pointer" : "auto" }} onClick={() => props.setSelectedData(cell.Price, row.fromDate, row.toDate)} className={classes.clickCell}>{cell.Price > 0 && cell.Price}</TableCell>
                        ))}
                    </TableRow>
                )
            })}
        </TableBody>        
    </Table>)

}

const useStyles = makeStyles(() => ({
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        paddingLeft: "5px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },

    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        paddingLeft: "0px",
        // borderTop: "1px solid #DEDEDE",
        // borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "30%",
        paddingLeft: "10px"
    },

    clickCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        paddingLeft: "0px",
        // borderTop: "1px solid #DEDEDE",
        // borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "30%",
        paddingLeft: "10px"
    },

    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%"

    }

}));